import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["all", "check", "page", "bar", "selectedCount", "allChecked"]
  }

  toggleAllCheckboxes(event) {
    if (this.allTargets.includes(event.target)) {
      this.allCheckedTarget.checked = true
    } else {
      this.allCheckedTarget.checked = false
    }

    const checkState = this.allTargets.includes(event.target) || this.pageTargets.includes(event.target)

    this.checkTargets.forEach((checkboxTarget) => {
      if (checkboxTarget.offsetWidth > 0 || checkboxTarget.offsetHeight > 0) {
        checkboxTarget.checked = checkState
      }
    })

    this.toggleActionsBar(event.target.value)
    this.dispatchChangeEvent()
  }

  toggleCheckbox() {
    if (
      !this.checkTargets.every((checkboxTarget) => {
        return checkboxTarget.checked
      })
    ) {
      this.allCheckedTarget.checked = false
    }

    const checkedTargets = this.checkTargets.filter((checkboxTarget) => {
      return checkboxTarget.checked
    })
    this.toggleActionsBar(checkedTargets.length)
    this.dispatchChangeEvent()
  }

  toggleActionsBar(numberCheckedTargets) {
    if (numberCheckedTargets > 0) {
      this.barTarget.classList.add("is-visible")
      this.selectedCountTarget.innerText = i18n.t("js.count_selected", {
        count: i18n.numberToDelimited(numberCheckedTargets, {
          separator: i18n.translations[i18n.locale].js.number.format.separator,
          delimiter: i18n.translations[i18n.locale].js.number.format.delimiter,
        }),
      })
    } else {
      this.barTarget.classList.remove("is-visible")
    }
  }

  dispatchChangeEvent() {
    const checkedTargets =
      this.allCheckedTarget.checked && this.hasPageTarget
        ? []
        : this.checkTargets.filter((checkboxTarget) => {
            return checkboxTarget.checked
          })

    this.dispatch("change", {
      detail: {
        allSelected: this.allCheckedTarget.checked,
        checked: checkedTargets.length,
        dataSets: checkedTargets.map((checkedTarget) => checkedTarget.dataset),
      },
    })
  }
}
